<template>
    <v-card class="cardSingleSKU">
        <v-card-text class="py-0">
            <!-- <pre>{{ item }}</pre> -->
            <v-container class="pa-0">
                <v-row column justify-center align-center>
                    <v-col cols="10" class="pb-0">
                        <nuxt-link
                            :id="`shop-img--viewProduct-${createPartNumberToSlug(
                                item.pn
                            )}`"
                            :to="createProductLink(item)"
                            no-prefetch
                            class="shop-img--viewProduct shop-viewProduct"
                        >
                            <EmbedCloudinary2
                                :is-saved-cart-item="isSavedCartItem"
                                :image-id="
                                    item.img
                                        ? item.img.replace('products/', '')
                                        : 'c3controls-icon-t'
                                "
                                :image-dir="item.img ? 'products' : 'logos'"
                                image-align="center"
                                classes="ma-0"
                                :alt="
                                    item.alt && item.alt[$i18n.locale]
                                        ? item.alt
                                        : {
                                              en: 'c3controls product',
                                              es: 'c3controls product',
                                          }
                                "
                                width="200"
                                height="110"
                            />
                        </nuxt-link>
                    </v-col>
                    <!-- FAVORITE HEART -->
                    <v-col
                        v-if="!isSavedCartItem"
                        cols="2"
                        class="py-0 px-0 pt-2 d-flex justify-space-around"
                    >
                        <FavoriteHeart
                            v-if="isShop || (isCheckout && item.isAvailable)"
                            :product-id="item.product_id"
                            :pn="item.pn"
                            class="mt-auto"
                        />
                    </v-col>
                    <v-col cols="12" v-if="!isSavedCartItem" class="pb-0 px-0">
                        <nuxt-link
                            :id="`shop-name--viewProduct-${createPartNumberToSlug(
                                item.pn
                            )}`"
                            :to="createProductLink(item)"
                            no-prefetch
                            class="shop-name--viewProduct shop-viewProduct"
                        >
                            {{
                                $i18n.locale === 'es'
                                    ? item.name_es
                                    : item.name_en
                            }}
                        </nuxt-link>
                    </v-col>
                    <v-col cols="12">
                        <v-container class="pa-0">
                            <v-row column justify-center align-center>
                                <!-- PRODUCT TITLE -->
                                <v-col
                                    cols="12"
                                    class="card-heading--singleSKU pa-0"
                                >
                                    <div v-if="customInputString">
                                        <span
                                            class="dollars"
                                            style="font-size: 0.75rem"
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'customInput',
                                                }"
                                            />:
                                            {{ customInputString }}
                                        </span>
                                    </div>
                                    <div v-if="item.pkgqty > 1">
                                        <span
                                            class="dollars"
                                            style="font-size: 0.75rem"
                                            :title="
                                                localize(
                                                    'orderMustBeInMultiplesOf',
                                                    [
                                                        {
                                                            var: `${item.pkgqty}`,
                                                        },
                                                    ]
                                                )
                                            "
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'minQty1Units',
                                                    variables: [
                                                        {
                                                            var: `${item.pkgqty}`,
                                                        },
                                                    ],
                                                }"
                                            />
                                        </span>
                                    </div>
                                    <div v-if="item.tariff">
                                        <span
                                            class="dollars"
                                            style="font-size: 0.75rem"
                                        >
                                            {{ item.pkgqty > 1 ? ' | ' : ''
                                            }}<TranslatableStringComponent
                                                :tstring="{
                                                    string: 'tariffApplies',
                                                }"
                                            />
                                        </span>
                                    </div>
                                    <!-- <AlertForRealTimeInventory
                                        :text="true"
                                        :itemAvailability="
                                            realTimeInventoryProductAvailability
                                        "
                                        :loading="loading"
                                        @checkCartProductAvailability="checkProductAvailability"
                                    /> -->
                                </v-col>

                                <!-- PRODUCT PART NUMBER (Checkout) -->
                                <v-col cols="12" class="py-0 px-0">
                                    <div class="card-pn--singleSKU">
                                        <strong
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'partNumber',
                                                }"
                                            />:</strong
                                        >
                                        <br />
                                        <nuxt-link
                                            :id="`shop-pn--viewProduct-${createPartNumberToSlug(
                                                item.pn
                                            )}`"
                                            :to="
                                                createProductLink(
                                                    item,
                                                    $i18n.locale
                                                )
                                            "
                                            class="shop-pn--viewProduct shop-viewProduct"
                                            ><TranslatableStringComponent
                                                v-if="item.isPartial"
                                                :tstring="{
                                                    string: 'configurable',
                                                }"
                                            />
                                            <span v-else>{{
                                                item.pn
                                            }}</span></nuxt-link
                                        >
                                        <v-btn
                                            text
                                            fab
                                            x-small
                                            dense
                                            color="primary"
                                            @click="handleClipboard()"
                                        >
                                            <span>
                                                <fa
                                                    :icon="['fal', 'copy']"
                                                    class="fa-lg"
                                            /></span>
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col cols="12" class="py-0 px-0">
                                    <div
                                        v-show="
                                            (!item.isPartial &&
                                                isAvailable(item) &&
                                                item.quantityInCart > 0 &&
                                                item.subTotalSalePrice) ||
                                            isSavedCartItem
                                        "
                                        class="card-subtotal--singleSKU text-right"
                                    >
                                        <TranslatableStringComponent
                                            v-if="
                                                !isCheckout || isSavedCartItem
                                            "
                                            :tstring="{ string: 'inCart' }"
                                        />
                                        <strong v-if="isCheckout"
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'subtotal',
                                                }"
                                            />:</strong
                                        >
                                    </div>
                                </v-col>
                                <!-- LIST PRICE -->
                                <v-col cols="6" class="py-0 px-0">
                                    <div class="card-price--singleSKU">
                                        <strong
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'listPrice',
                                                }"
                                            />:</strong
                                        >
                                        <span v-if="!item.isPartial"
                                            ><del
                                                >${{
                                                    item.list_price
                                                        .toFixed(2)
                                                        .toString()
                                                        .replace(
                                                            /(\d)(?=(\d{3})+(?!\d))/g,
                                                            '$1,'
                                                        )
                                                }}</del
                                            >
                                            {{
                                                item.pkgqty > 1
                                                    ? 'per unit'
                                                    : ''
                                            }}</span
                                        >
                                        <TranslatableStringComponent
                                            v-else
                                            :tstring="{
                                                string: 'configurable',
                                            }"
                                        />
                                    </div>
                                </v-col>
                                <!-- SUBTOTAL -->
                                <v-col cols="6" class="py-0 px-0">
                                    <div
                                        v-if="
                                            (isAvailable(item) &&
                                                item.quantityInCart > 0 &&
                                                item.subTotalSalePrice) ||
                                            isSavedCartItem
                                        "
                                        class="card-price--singleSKU text-right"
                                    >
                                        <span
                                            ><del>
                                                {{
                                                    dollars(
                                                        item.subTotalListPrice
                                                    )
                                                }}</del
                                            ></span
                                        >
                                    </div>
                                </v-col>
                                <!-- SUBTOTAL (LIST PRICE) -->
                                <!-- <v-col cols="6" class="py-0"> </v-col> -->
                                <!-- YOUR PRICE -->
                                <v-col
                                    cols="6"
                                    class="py-0 px-0 d-flex align-center"
                                >
                                    <div class="card-price--singleSKU">
                                        <strong
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'yourPrice',
                                                }"
                                            />:</strong
                                        >
                                        <span
                                            v-if="
                                                item.sale_price &&
                                                !item.isPartial
                                            "
                                            class="dollars"
                                            >${{
                                                item.sale_price
                                                    .toFixed(2)
                                                    .toString()
                                                    .replace(
                                                        /(\d)(?=(\d{3})+(?!\d))/g,
                                                        '$1,'
                                                    )
                                            }}
                                            {{
                                                item.pkgqty > 1
                                                    ? 'per unit'
                                                    : ''
                                            }}</span
                                        >
                                        <TranslatableStringComponent
                                            v-else-if="item.isPartial"
                                            :tstring="{ string: 'saveUpTo40' }"
                                        />
                                        <span v-else>
                                            <v-progress-circular
                                                :size="14"
                                                width="1"
                                                color="primary"
                                                indeterminate
                                            ></v-progress-circular>
                                        </span>
                                    </div>
                                </v-col>
                                <!-- SUBTOTAL (YOUR PRICE) -->
                                <v-col
                                    cols="6"
                                    class="py-0 px-0 d-flex justify-end"
                                >
                                    <div
                                        v-if="
                                            (!item.isPartial &&
                                                isAvailable(item) &&
                                                item.quantityInCart > 0 &&
                                                item.subTotalSalePrice) ||
                                            isSavedCartItem
                                        "
                                        class="card-price--singleSKU text-right"
                                    >
                                        <span class="dollars">
                                            {{
                                                dollars(item.subTotalSalePrice)
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        v-if="
                                            item.quantityInCart === 0 &&
                                            !item.isPartial
                                        "
                                    >
                                        <v-btn
                                            :id="`shop-addToCart-${createPartNumberToSlug(
                                                item.pn
                                            )}`"
                                            height="40"
                                            color="primary"
                                            class="ml-1 overline add-to-cart"
                                            @click="addToCart()"
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'addToCart',
                                                }"
                                        /></v-btn>
                                    </div>
                                    <div
                                        v-if="item.isPartial"
                                        class="card-qty--singleSKU d-flex text-right"
                                    >
                                        <v-btn
                                            height="40"
                                            color="secondary"
                                            class="ml-1 overline"
                                            :href="
                                                createPartialProductLink(item)
                                            "
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'configure',
                                                }"
                                        /></v-btn>
                                    </div>
                                </v-col>
                                <!-- PLEASE CONFIGURE -->
                                <!-- <v-col v-if="item.isPartial" cols="12">
                                    <div style="width:50%">
                                        <strong
                                            >Please configure yourproduct.</strong
                                        >
                                    </div>
                                </v-col> -->
                                <!-- <v-col cols="12">
                                    <pre>{{ item }}</pre>
                                </v-col> -->
                                <v-col cols="12" class="py-0 px-0 pt-3">
                                    <div v-if="isFlexibleQuantity" class="mr-4">
                                        <v-radio-group
                                            class="ma-0 pt-0"
                                            v-model="pkgQtyType"
                                            dense
                                            mandatory
                                            hide-details
                                        >
                                            <v-radio value="standard"
                                                ><template v-slot:label>
                                                    <div class="caption">
                                                        <TranslatableStringComponent
                                                            :tstring="{
                                                                string:
                                                                    'standardPkgQty',
                                                            }"
                                                        />
                                                        <span
                                                            class="primary--text"
                                                            >({{
                                                                item.pkgqty
                                                            }})</span
                                                        >
                                                    </div>
                                                </template></v-radio
                                            >
                                            <v-radio value="non-standard">
                                                <template v-slot:label>
                                                    <div class="caption">
                                                        <TranslatableStringComponent
                                                            :tstring="{
                                                                string:
                                                                    'nonStandardPkgQty',
                                                            }"
                                                        />
                                                        <span
                                                            class="primary--text"
                                                            >(* $10
                                                            <TranslatableStringComponent
                                                                :tstring="{
                                                                    string:
                                                                        'handlingFeeApplies',
                                                                }"
                                                            />)</span
                                                        >
                                                    </div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </div>
                                    <div
                                        v-if="item.quantityInCart > 0"
                                        class="d-flex justify-space-between"
                                    >
                                        <div
                                            v-if="$vuetify.breakpoint.xs"
                                            class="d-flex align-center"
                                        >
                                            <strong>
                                                <TranslatableStringComponent
                                                    :tstring="{
                                                        string: 'quantity',
                                                    }"
                                                />
                                                :</strong
                                            >
                                        </div>
                                        <div v-else>
                                            <!-- PRODUCT ACTIONS -->
                                            <!-- EDIT -->
                                            <v-btn
                                                outlined
                                                small
                                                color="primary"
                                                @click="handleEdit(item)"
                                                ><TranslatableStringComponent
                                                    :tstring="{
                                                        string: 'edit',
                                                    }"
                                            /></v-btn>
                                            <!-- REMOVE -->
                                            <v-btn
                                                outlined
                                                small
                                                color="primary"
                                                @click.stop="initRemoval()"
                                                ><TranslatableStringComponent
                                                    :tstring="{
                                                        string: 'remove',
                                                    }"
                                            /></v-btn>
                                        </div>

                                        <div>
                                            <InputFieldStepper
                                                :item="item"
                                                :pkgQtyType="pkgQtyType"
                                            />
                                        </div>
                                    </div>

                                    <div
                                        v-if="!item.isPartial"
                                        class="text-right"
                                    >
                                        <div v-if="!isAvailable(item)">
                                            <v-progress-circular
                                                v-if="availibilityChecked"
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                            <v-alert
                                                v-else
                                                type="error"
                                                dense
                                                outlined
                                                ><TranslatableStringComponent
                                                    :tstring="{
                                                        string:
                                                            'itemUnavailable',
                                                    }"
                                            /></v-alert>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col
                                    v-if="
                                        $vuetify.breakpoint.xs &&
                                        item.quantityInCart > 0
                                    "
                                    cols="6"
                                    class="px-0 pb-0"
                                >
                                    <v-btn
                                        text
                                        block
                                        color="primary"
                                        tile
                                        small
                                        style="border-right: 1px solid"
                                        @click="handleEdit(item)"
                                        ><TranslatableStringComponent
                                            :tstring="{
                                                string: 'edit',
                                            }" /></v-btn
                                ></v-col>
                                <v-col
                                    v-if="
                                        $vuetify.breakpoint.xs &&
                                        item.quantityInCart > 0
                                    "
                                    cols="6"
                                    class="px-0 pb-0"
                                >
                                    <v-btn
                                        text
                                        block
                                        color="primary"
                                        tile
                                        small
                                        @click.stop="initRemoval()"
                                        ><TranslatableStringComponent
                                            :tstring="{
                                                string: 'remove',
                                            }" /></v-btn
                                ></v-col>
                                <!-- <v-col cols="12">
                                    <pre>{{ item }}</pre>
                                </v-col> -->
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
            <v-dialog v-model="dialog" width="500" persistent>
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        <TranslatableStringComponent
                            :tstring="{ string: 'remove' }"
                        />
                        {{ removableItem.pn }}?
                    </v-card-title>
                    <v-card-text>
                        <p>
                            <TranslatableStringComponent
                                :tstring="{
                                    string: 'confirmRemoveFromCart',
                                    variables: [
                                        {
                                            var: removableItem.prod_quantity,
                                            tag: 'strong',
                                        },
                                        {
                                            var: removableItem.pn,
                                            tag: 'strong',
                                        },
                                    ],
                                }"
                            />
                        </p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="dialog = false">
                            <TranslatableStringComponent
                                :tstring="{ string: 'keep' }"
                            />
                        </v-btn>
                        <v-btn color="error" text @click="removeItem()">
                            <TranslatableStringComponent
                                :tstring="{ string: 'remove' }"
                            />
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>
<script>
import cardSingleSKU from '~/mixins/cardSingleSKU'
export default {
    name: 'CardSingleSKUMobile',
    mixins: [cardSingleSKU],
}
</script>
